<template>
    <div>
        <div v-if="!item.sale_item && !(showNoPrice && incVat)">
            <span v-if="showDayPrice">
                <currency :amount="dayPrice" />
                Per Day
            </span>

            <span v-if="showDayPrice && showWeekPrice"> | </span>

            <span v-if="showWeekPrice">
                <currency :amount="weekPrice" />
                Per Week
            </span>

            <span v-if="showNoPrice">
                <v-icon small>mdi-phone</v-icon>
                Call for a quote
            </span>

            <slot />
        </div>

        <div v-if="item.sale_item">
            <span v-if="!showNoSalesPrice">
                <currency :amount="salePrice" />
            </span>

            <span v-if="showNoSalesPrice">
                <v-icon small>mdi-phone</v-icon>
                Call for a quote
            </span>

            <slot />
        </div>
    </div>
</template>

<script>
import Currency from "@/Components/Catalogue/Currency";

export default {
    name: "RentalRates",

    components: { Currency },

    props: {
        item: {
            type: Object,
            required: true,
        },

        incVat: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        vatRate() {
            return this.incVat ? 1.2 : 1;
        },

        dayPrice() {
            return this.item.day_rate * this.vatRate;
        },

        weekPrice() {
            return this.item.week_rate * this.vatRate;
        },

        salePrice() {
            return this.item.sale_price * this.vatRate;
        },

        showDayPrice() {
            return this.item.day_rate && !this.item.hide_price;
        },

        showWeekPrice() {
            return this.item.week_rate && !this.item.hide_price;
        },

        showNoPrice() {
            return !this.showDayPrice && !this.showWeekPrice;
        },

        showNoSalesPrice() {
            return !this.item.sale_price;
        },
    },
};
</script>

<style scoped></style>
